import { alpha, Box, Theme } from '@mui/material';
import { FC } from 'react';
import TextInput from '../../form/text-input';
import { createUseStyles } from 'react-jss';
import { getBreakpoint } from '@/theme';

interface Props {
  name: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}
const useStyles = createUseStyles((theme: Theme) => ({
  sidebarSearch: {
    borderTop: `1px solid ${alpha(theme.palette.text.primary, 0.3)}`,
    borderBottom: `1px solid ${alpha(theme.palette.text.primary, 0.3)}`,
    marginBottom: 16,
    color: theme.palette.text.primary,
    '& .MuiInputBase-input': {
      color: theme.palette.text.primary,
    },
    '& .MuiInputBase-root': {
      paddingLeft: '0 !important',
      paddingRight: '0 !important',
    },
    '& input.MuiInputBase-input': {
      paddingLeft: 4,
    },
  },
  [getBreakpoint('md')]: {
    sidebarSearch: {
      marginBottom: 8,
    },
  },
}));

const SidebarSearch: FC<Props> = ({ name, value, onChange, placeholder }) => {
  const styles = useStyles();
  return (
    <Box className={styles.sidebarSearch}>
      <TextInput
        name={name}
        value={value}
        onChange={onChange}
        size="small"
        startIcon="search"
        placeholder={placeholder}
        clearable
        noBorder
      />
    </Box>
  );
};

export default SidebarSearch;
